import { Modal, Radio, Space } from "antd";
import React from "react";
import ErrorPage from "../Notification/Error";

function Payment({ props }) {
  const {
    isVisible,
    loading,
    onSubmitCash,
    cashError,
    onCancel,
    onCash,
    cash,
    isBank,
  } = props;

  return (
    <Modal
      title={null}
      visible={isVisible}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <p className="colors-blue text-2xl mb-3 font-bold header-title-bold ">
          Metode Pembayaran
        </p>
        <p className="colors-gray text-base header-content ">
          Pilih metode pembayaran anda
        </p>
        <div className="mt-6">
          <Radio.Group onChange={onCash} value={cash}>
            <Space direction="vertical">
              {isBank.map((it, index) => (
                <Radio key={index} value={it.id}>
                  <div className="flex w-full items-center">
                    <img src={it.logo} alt="icon-bni" className="w-5 h-auto" />
                    <p className="ml-2 mb-1 header- colors-blue font-semibold text-lg">
                      {it.name}
                    </p>
                  </div>
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>
        <div>
          {cashError.length > 0 && (
            <div className="mt-5">
              <ErrorPage key={1} props={{ idx: 1, message: cashError }} />
            </div>
          )}
          <button
            disabled={loading}
            onClick={onSubmitCash}
            className="btn-blue w-full p-3 mt-8 focus:outline-none"
          >
            <div className="text-white lg:text-lg">Pilih Pembayaran</div>
          </button>
          <p
            onClick={onCancel}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Batal
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Payment;
